import { parseLocaleCode } from "@notemeal/locale-utils";
/**
 * Passio accepts any valid BCP-47 language tag or ISO 639-1 code for product localization.
 *
 * @see https://passio.gitbook.io/nutrition-ai/rest-api/api-overview/localization
 */
const PASSIO_PRODUCT_LOCALIZATION_PATTERN = /^[a-z]{2,3}(-[A-Za-z0-9]{2,8})*$/;
export const isValidPassioProductLocalizationCode = (value) => {
    const trimmed = value?.trim();
    if (!trimmed) {
        return false;
    }
    return PASSIO_PRODUCT_LOCALIZATION_PATTERN.test(trimmed);
};
/** User-facing region or country name without BCP-47 codes (e.g. `en-US` → `United States`). */
export const getPassioProductLocalizationRegionDisplayName = (localeCode, appLocale = "en") => {
    const { trimmedLocaleCode, language, region } = parseLocaleCode(localeCode);
    if (!trimmedLocaleCode) {
        return localeCode;
    }
    try {
        if (region) {
            const regionNames = new Intl.DisplayNames([appLocale], { type: "region" });
            return regionNames.of(region) ?? trimmedLocaleCode;
        }
        if (language) {
            const languageNames = new Intl.DisplayNames([appLocale], { type: "language" });
            return languageNames.of(language) ?? trimmedLocaleCode;
        }
    }
    catch {
        return trimmedLocaleCode;
    }
    return trimmedLocaleCode;
};
//# sourceMappingURL=passioProductLocalizationLocales.js.map